module.exports = "/assets/data/7c72de6bc1cfb979799eeb534a2c05e7-MK40.data.json";